import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-tile3-country-indiv-stack.component.scss';
var ContactTile3CountryIndivStack = /** @class */ (function (_super) {
    tslib_1.__extends(ContactTile3CountryIndivStack, _super);
    function ContactTile3CountryIndivStack(element) {
        return _super.call(this, element) || this;
    }
    ContactTile3CountryIndivStack.prototype.init = function () { };
    ContactTile3CountryIndivStack.prototype.bindEvents = function () { };
    return ContactTile3CountryIndivStack;
}(Base));
export { ContactTile3CountryIndivStack };



//////////////////
// WEBPACK FOOTER
// ./components/contact-tile3-country-indiv-stack/contact-tile3-country-indiv-stack.component.ts
// module id = 212
// module chunks = 0